module.exports = __webpack_public_path__ + "img/blog8.f038c7dc.jpg";